import React, { Component } from 'react';
import PropTypes from 'prop-types';

const queryString = require('query-string');

class LocaleComponent extends Component {
  constructor(props) {
    super(props);

    this._all = 'All';
  }

  localeMessage(msgId) {
    const { selectedLocale, translations } = this.props;
    if (!msgId) {
      return '';
    } else if (translations && translations[selectedLocale]) {
      return translations[selectedLocale][msgId.toUpperCase()] || msgId;
    } else {
      return msgId;
    }
  }

  getMcId() {
    const { location, match } = this.props;
    const parsed = location ? queryString.parse(location.search) : {};
    return match.params.mcId || parsed.mcId || localStorage.getItem('mcId');
  }

  parseParams(search) {
    return queryString.parse(search);
  }

  checkParams() {
    const { location } = this.props;
    const { params } = this.state;
    const parsed = queryString.parse(location.search);
    const newParams = {};

    newParams.mcId = this.getMcId();
    if (Object.keys(this.state.params).reduce((prev, key) => {
      if (key === 'modal') return prev;
      if (parsed[key] && parsed[key] !== params[key]) {
        newParams[key] = parsed[key];
        return true;
      }
      return prev;
    }, false)) {
      return newParams;
    } else {
      return null;
    }
  }

  stringfyWithNew(param) {
    const params = Object.assign({}, this.state.params, param);
    return '?' + queryString.stringify(params);
  }

  stringfy(params) {
    return '?' + queryString.stringify(params);
  }

  mergeParams(newParams) {
    if (newParams) {
      this.setState({ params: Object.assign({}, this.state.params, newParams) });
    }
  }

  mergeValues(values, newValues) {
    return Object.assign({}, values, newValues);
  }
}

LocaleComponent.propTypes = {
  selectedLocale: PropTypes.string,
};

LocaleComponent.defaultProps = {
  selectedLocale: 'en',
  translations: {},
};

export default LocaleComponent;



// WEBPACK FOOTER //
// ./src/LocaleComponent.js